import { render, staticRenderFns } from "./self-lottery-draw.vue?vue&type=template&id=467603b2&"
import script from "./self-lottery-draw.vue?vue&type=script&lang=js&"
export * from "./self-lottery-draw.vue?vue&type=script&lang=js&"
import style0 from "./self-lottery-draw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports